import { render, staticRenderFns } from "./TargetDescriptorCombo.vue?vue&type=template&id=23d9c64d&scoped=true&lang=html"
import script from "./TargetDescriptorCombo.vue?vue&type=script&lang=js"
export * from "./TargetDescriptorCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d9c64d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCheckbox,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle})
